import React from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { TYPES_BY_CONSTRUCTION } from 'constants/vessel';

/**
 * @param {{
 *  getError?: Function,
 *  changeField: Function,
 *  confirmed?: boolean,
 *  type: '' | 'SID' | 'TWEEN',
 *  modifiedFields?: any,
 *  underStyle?: React.CSSProperties,
 * }} props 
 * @returns 
 */
const TypeByConstruction = (props) => {
    const {
        getError, changeField, confirmed, type, modifiedFields, underStyle, 
    } = props;

    return (
        <SelectField
            value={type}
            disabled={confirmed}
            onChange={(_e, _index, value) => {
                changeField({
                    field: 'typeByConstruction',
                    value,
                });
            }}
            maxHeight={200}
            name='typeByConstruction'
            floatingLabelText='Type By Construction'
            errorText={getError && getError('typeByConstruction')}
            fullWidth

            underlineStyle={modifiedFields && modifiedFields.includes('typeByConstruction') ? underStyle : null}
        >
            {
                TYPES_BY_CONSTRUCTION.map((t, i) => (<MenuItem
                    key={`${t}_${i}`}
                    value={t}
                    primaryText={t}
                />))
            }
        </SelectField>
    );
};

export default TypeByConstruction;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/TypeByConstruction.jsx